import { createFileRoute, redirect } from '@tanstack/react-router'

export const Route = createFileRoute('/stream/$id')({
  loader: ({ params }) =>
    redirect({
      statusCode: 301,
      throw: false,
      to: `/livestream/${params.id}`,
    }),
})
